export default __webpack_public_path__ + "static/media/vip8.4f0f164b.webp";